import { Typography } from "@mui/material";
import type { LicenseCode } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type DescriptionProps = {
  licenseType: LicenseCode;
};

export const Description = ({ licenseType }: DescriptionProps) => {
  const { t } = useResource();

  return (
    <Typography mb={1}>
      {t(Resources.Components.LicensePicker.LicenseDescription[licenseType])}
    </Typography>
  );
};
